import {BaseWrapper} from '../../framework/parameters/BaseWrapper';
import {Profile} from '../message/Profile';
import {ProfileCriteria} from './ProfileCriteria';
import {ProfileScenario} from './ProfileScenario';

export class ProfileWrapper extends BaseWrapper<Profile, ProfileCriteria, ProfileScenario>  {}

